export function initializeRegulations() {
    return {
        type: 'REGULATIONS_INITIALIZE',
    }
}

export function clearRegulationError() {
    return {
        type: 'CLEAR_REGULATION_ERRORS',
    }
}

export function closeGetRegulationsFetch() {
    return {
        type: 'API_GET_REGULATIONS_CLOSE_FETCH',
    }
}

export function closePostRegulationFetch() {
    return {
        type: 'API_POST_REGULATION_CLOSE_FETCH',
    }
}

export function closePutRegulationFetch() {
    return {
        type: 'API_PUT_REGULATION_CLOSE_FETCH',
    }
}

export function closeDeleteRegulationFetch() {
    return {
        type: 'API_DELETE_REGULATION_CLOSE_FETCH',
    }
}

export function getRegulations() {
    return {
        type: 'API_GET_REGULATIONS',
        payload: {
            request: {
                method: 'GET',
                url: '/regulations'
            }
        }
    }
}

export function createRegulation(regulation) {
    return {
        type: 'API_CREATE_REGULATION',
        payload: {
            request: {
                method: 'POST',
                url: '/regulations',
                data: regulation,
            }
        }
    }
}

export function updateRegulation(regulation) {
    return {
        type: 'API_UPDATE_REGULATION',
        payload: {
            request: {
                method: 'PUT',
                url: `/regulations/${regulation.id}`,
                data: regulation,
            }
        }
    }
}

export function deleteRegulation(regulation) {
    return {
        type: 'API_DELETE_REGULATION',
        payload: {
            request: {
                method: 'DELETE',
                url: `/regulations/${regulation.id}`,
            }
        }
    }
}

export function setEditRegulation(regulation) {
    return {
        type: 'SET_EDIT_REGULATION',
        payload: {
            regulation: regulation
        },
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/regulations.js